import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _assertThisInitialized from '@babel/runtime/helpers/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Swal from 'sweetalert2';
import { dgWithReducer } from 'dg-utils';
import { r as reducer } from './reducer-d2bd51aa.js';
import { u as updatePost, h as uploadImage, b as setPostLoading } from './post.actions-dcd472e5.js';
import { B as BlogForm } from './blogForm.component-cddf3030.js';

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var EditPostPage = /*#__PURE__*/function (_Component) {
  _inherits(EditPostPage, _Component);

  var _super = _createSuper$1(EditPostPage);

  function EditPostPage(props) {
    var _this;

    _classCallCheck(this, EditPostPage);

    _this = _super.call(this, props);
    _this.state = {
      time: 0,
      start: 0
    };
    _this.startTimer = _this.startTimer.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(EditPostPage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startTimer();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.state.time === 100) {
        this.focus();
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      document.getElementsByClassName('public-DraftEditor-content')[0].focus();
      console.log('focused');
    }
  }, {
    key: "startTimer",
    value: function startTimer() {
      var _this2 = this;

      this.timer = setInterval(function () {
        return _this2.setState({
          time: _this2.state.time + 10
        });
      }, 10);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$post, _this$props$post2;

      return /*#__PURE__*/React.createElement("div", {
        className: "blogEditor"
      }, this.props.post && this.props.post.title !== '' ? /*#__PURE__*/React.createElement(BlogForm, {
        onSubmit: this.props.onSubmit,
        initialValues: this.props.post,
        clearForm: true,
        uploadImage: this.props.uploadImage,
        post: this.props.post,
        blog: this.props.blog,
        headerImageAccept: this.props.headerImageAccept,
        header_image: (_this$props$post = this.props.post) === null || _this$props$post === void 0 ? void 0 : _this$props$post.header_image,
        tags: (_this$props$post2 = this.props.post) === null || _this$props$post2 === void 0 ? void 0 : _this$props$post2.tags
      }) : this.props.noPostComponent ? this.props.noPostComponent : /*#__PURE__*/React.createElement("h1", null, "No Post Selected"));
    }
  }]);

  return EditPostPage;
}(Component);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var AdminPostEdit = /*#__PURE__*/function (_Component) {
  _inherits(AdminPostEdit, _Component);

  var _super = _createSuper(AdminPostEdit);

  function AdminPostEdit(props) {
    var _this;

    _classCallCheck(this, AdminPostEdit);

    _this = _super.call(this, props);
    _this.onSubmit = _this.onSubmit.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(AdminPostEdit, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.posts && this.props.posts.currentPost && Object.keys(this.props.posts.currentPost).length <= 0) {
        this.props.history.push("/admin/posts");
      }
    }
  }, {
    key: "onSubmit",
    value: function onSubmit(data) {
      var _this2 = this;

      this.props.setPostLoading(true);
      console.log("Form Submit :: Edit");
      var form = new FormData();
      var body = data;

      if (data.header_image && typeof data.header_image !== "string" && data.header_image.length > 0) {
        for (var index = 0; index < data.header_image.length; index++) {
          form.append("updated_header_image", data.header_image[index]);
        }

        delete body.header_image;
      }

      form.append("post_details", JSON.stringify(body));
      console.log(form);
      this.props.updatePost(data._id, form).then(function (res) {
        Swal.fire("Success!", "".concat(res.message), "success");
        window.scrollTo(0, 0);

        _this2.props.history.push("/admin/posts");
      })["catch"](function (res) {
        Swal.fire("Couldn't save Post!", "".concat(res.message), "error");
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "redux-blogs-container"
      }, this.props.sidebar ? this.props.sidebar : "", /*#__PURE__*/React.createElement("main", null, /*#__PURE__*/React.createElement("div", {
        className: "redux-blogs-header-container"
      }, /*#__PURE__*/React.createElement("h1", null, "Admin Edit Post")), /*#__PURE__*/React.createElement(EditPostPage, {
        onSubmit: this.onSubmit,
        post: this.props.posts.currentPost,
        uploadImage: this.props.uploadImage,
        blog: this.props.posts,
        noPostComponent: this.props.noPostComponent
      })));
    }
  }]);

  return AdminPostEdit;
}(Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    posts: state.blogs
  };
};

var adminEditPost = connect(mapStateToProps, _defineProperty({
  updatePost: updatePost,
  uploadImage: uploadImage,
  setPostLoading: setPostLoading
}, "updatePost", updatePost))(dgWithReducer(AdminPostEdit, "blogs", reducer));

export { EditPostPage as E, adminEditPost as a };
